export default {
    arts:{id:"1", label:"Arts"}, 
    comedy:{id:"2", label:"Comedy"}, 
    childrenAndEducation:{id:"3", label:"Children and Education"}, 
    dPlusE:{id:"4", label:"D+E"}, 
    documentaries:{id:"5", label:"Documentaries"}, 
    drama:{id:"6", label:"Drama"}, 
    factualEntertainment:{id:"7", label:"Factual Entertainment"}, 
    factualFeatures:{id:"8", label:"Factual Features"}, 
    lightEntertainment:{id:"9", label:"Light Entertainment"}, 
    liveEvents:{id:"10", label:"Live Events"}, 
    musicProgramming:{id:"11", label:"Music Programming"}, 
    newsAndCurrentAffairs:{id:"12", label:"News and Current Affairs"}, 
    NHU:{id:"13", label:"NHU"}, 
    promos:{id:"14", label:"Promos"}, 
    sport:{id:"15", label:"Sport"}, 
    worldService:{id:"16", label:"World Service"}, 
}